import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { Calendar, Loader } from "react-feather";
import { Navbar } from "./Navbar";

const api = process.env.REACT_APP_API_URL;

const Appointment = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    preferred_time: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.preferred_time) {
      toast.error("Name, email, and preferred time are required.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${api}appointment/book/`, form, { withCredentials: true });
      navigate("/appointment/confirmed");
    } catch (err) {
      const msg = err.response?.data?.error || "Failed to submit. Please try again.";
      toast.error(msg);
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-b from-sky-50 to-white flex items-center justify-center px-4 py-16">
        <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-lg">
          <div className="flex items-center gap-3 mb-2">
            <Calendar className="text-orange-500 w-7 h-7" />
            <h1 className="text-2xl font-bold text-gray-800">Book a Resume Review</h1>
          </div>
          <p className="text-gray-500 text-sm mb-6">
            Request a 30-minute one-on-one session with one of our resume specialists.
            We'll reach out within 24 hours to confirm.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Jane Smith"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="jane@example.com"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone (optional)</label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+1 (555) 000-0000"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Preferred Date & Time *
              </label>
              <input
                type="text"
                name="preferred_time"
                value={form.preferred_time}
                onChange={handleChange}
                placeholder="e.g. Monday May 12, 2–3 PM EST"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Anything specific you'd like us to focus on? (optional)
              </label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="e.g. Career change, gaps in employment, senior-level positioning…"
                rows={3}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-300 resize-none"
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="w-full py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-400 disabled:opacity-50 transition"
            >
              {submitting ? (
                <span className="flex items-center justify-center gap-2">
                  <Loader className="animate-spin w-5 h-5" /> Submitting…
                </span>
              ) : (
                "Request Appointment"
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Appointment;
